'use client';

import { c as _c } from "react/compiler-runtime";
import ButtonBigCall from '@components/button-big-call/ButtonBigCall';
import { useDeviceScreen } from '@lib/layouts/DeviceScreenProvider';
import { separateArray } from '@lib/tools/_separateArray';
import { useSelector } from 'react-redux';
import style from './ButtonsHideAmount.module.scss';
const ButtonsHideAmount = t0 => {
  const $ = _c(6);
  const {
    flat,
    amount,
    info
  } = t0;
  const {
    isMobile
  } = useDeviceScreen();
  const advantages = useSelector(_temp);
  if (flat.attributes?.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== advantages || $[1] !== amount || $[2] !== flat.attributes || $[3] !== info || $[4] !== isMobile) {
    const activeAttributes = Object.entries(flat?.attributes)?.filter(_temp2)?.map(_temp3);
    const activeAdvantages = advantages?.filter(advantage => activeAttributes?.includes(advantage.value));
    const tooltipElements = separateArray(activeAdvantages, amount)?.visible?.map(_temp4);
    t1 = <div className={style.btn}><div className={info ? style.btn__wrapp__info : style.btn__wrapp}>{tooltipElements}</div>{separateArray(activeAdvantages, amount)?.unvisible?.length !== 0 && <div className={style.btn__advantages}>{!isMobile ? <div className={style.btn__advantages__wrapp}><ButtonBigCall key={separateArray(activeAdvantages, amount)?.unvisible?.length} text={`+ ${separateArray(activeAdvantages, amount)?.unvisible?.length}`} className={style.btn__special__unvisible} /></div> : <ButtonBigCall key={separateArray(activeAdvantages, amount)?.unvisible?.length} text={`+${separateArray(activeAdvantages, amount)?.unvisible?.length}`} className={style.btn__special__unvisible} />}<div className={style.btn__hideAdv}>{separateArray(activeAdvantages, amount)?.unvisible?.map(_temp5)}</div></div>}</div>;
    $[0] = advantages;
    $[1] = amount;
    $[2] = flat.attributes;
    $[3] = info;
    $[4] = isMobile;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default ButtonsHideAmount;
function _temp(state) {
  return state?.filters?.filterParameters?.byCheckbox?.advantages;
}
function _temp2(item) {
  return item.includes(true);
}
function _temp3(item_0) {
  return item_0.slice(0, 1).toString();
}
function _temp4(item_1) {
  return <ButtonBigCall key={item_1.id} text={item_1.name} className={style.btn__special} />;
}
function _temp5(el) {
  return <div key={el.id}> {el.name} </div>;
}